import { createStore } from 'vuex'

export default createStore({
  state: {
    chats: [],
    chat: {
      id: "",
      typeUser: '',
      idConversation: "",
      date: "",
      message: "",
    },
    cart: JSON.parse(localStorage.getItem('cart') || '[]'),
  },
  mutations: {
    SYNC_CART(state) {
      state.cart = JSON.parse(localStorage.getItem('cart') || '[]')
    },
    ADD_TO_CART(state, product) {
      state.cart = JSON.parse(localStorage.getItem('cart') || '[]')
      const item = state.cart.find(i => i.textId === product.textId);
      const qtyToAdd = product.quantity !== undefined ? product.quantity : 1;

      if (item) {
        item.quantity = (item.quantity || 0) + qtyToAdd;
      } else {
        state.cart.push({
          ...product,
          quantity: qtyToAdd
        });
      }
      localStorage.setItem('cart', JSON.stringify(state.cart));
      window.dispatchEvent(new Event('cart-updated'));
    },
    REMOVE_FROM_CART(state, index) {
      const currentCart = JSON.parse(localStorage.getItem('cart') || '[]')
      currentCart.splice(index, 1)
      state.cart = currentCart
      localStorage.setItem('cart', JSON.stringify(state.cart))
      window.dispatchEvent(new Event('cart-updated'))
    },
    CLEAR_CART(state) {
      state.cart = []
      localStorage.setItem('cart', JSON.stringify(state.cart))
      window.dispatchEvent(new Event('cart-updated'))
    },
    cargarchat(state, payload) {
      const chatsArray = payload
      state.chats = chatsArray
    },
    setchat(state, payload) {
      state.chats.push(payload)
    },
  },

  actions: {
    async loadChat({ commit }) {
      try {
        const res = await fetch(`https://wimportaciones-b7da1-default-rtdb.firebaseio.com/chat/${localStorage.getItem('token_chat')}.json`)
        const dataDB = await res.json()
        const arrayChats = []
        for (let id in dataDB) {
          arrayChats.push(dataDB[id])
        }
        commit('cargarchat', arrayChats)

      } catch (error) {
        console.log(error)
      }
    },

    async setDatoschats({ commit }, chat) {
      // ... existing code ...
      commit('setchat', chat)
    },
    addToCart({ commit }, product) {
      commit('ADD_TO_CART', product);
    },
    removeFromCart({ commit }, index) {
      commit('REMOVE_FROM_CART', index)
    },
    clearCart({ commit }) {
      commit('CLEAR_CART')
    },
  },
  modules: {
  }
})
